import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { ApiKeyDetails } from "./components/ApiKeyDetails";

export function ApiKeyPage() {
  return (
    <Page title="API Key Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ApiKeyDetails />
      </Container>
    </Page>
  );
}
